import { Injectable } from '@angular/core';
import { Capacitor  } from '@capacitor/core';
//import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";

@Injectable({
  providedIn: 'root',
})
export class DataLayerService {

  constructor(
    ) {}

  public pushOnDataLayer(obj: any) {/*
    if (Capacitor.platform !== 'web') {
      analyticsFirebase.logEvent(obj.name, obj.params)
      .then(() => console.log('Event successfully tracked'))
      .catch(err => console.log('Error tracking event:', err));
    }*/
    if (Capacitor.getPlatform() !== 'web') {
      // FirebaseAnalytics.logEvent({
      //   name: obj.name,
      //   params: obj.params
      // });
    }
  }

  public pushCustomEventGTM(nameEvent: string){
    if (Capacitor.getPlatform() === 'web') {
      (<any>window).dataLayer = (<any>window).dataLayer || [];
      (<any>window).dataLayer.push({
        event: nameEvent
      });
    }
  }

  public pushPageView(){
    if (Capacitor.getPlatform() === 'web') {
      const pageLocation = window.location.href;
      const pagePath = window.location.pathname;
      const pageTitle = document.title;

      (<any>window).dataLayer = (<any>window).dataLayer || [];
      (<any>window).dataLayer.push({
        event: 'page_view',
        page_location: pageLocation,
        page_path: pagePath,
        page_title: pageTitle
      });
    }
  }

}
